export default class Header {
  constructor(el) {
    this.DOM = { el: el };
    this.DOM.header = document.querySelector('.header');
    this.state = {};
    this.state.elHeight = this.DOM.header.offsetHeight;
    this.state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    this.toggleView = this.toggleView.bind(this);

    this.init();
  }

  init() {
    if (!this.DOM.el) return;
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', this.toggleView);
  }

  toggleView() {
    this.state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.DOM.el.classList.toggle('sticky-visible', this.state.scrollTop > this.state.elHeight + 100);
  }
}